import React from 'react'
import BackLink, { type BackTarget } from '@components/BackLink'
import { HeadingBlock, HeadingRow, HeadingSubtitle, HeadingTitle } from './PageHeading.styles'

interface PageHeadingProps {
	title: string
	/** Count / context line under the title, e.g. "3 flights". */
	subtitle?: string
	/** The page's parent; renders the back arrow left of the title. */
	backTo?: BackTarget
}

/**
 * The standard section-page heading: display-font title over a muted count
 * line, with the back arrow to the page's parent on the title's left. One atom for the member section pages (flights, accommodations,
 * files) and the public section pages, so the two surfaces can't drift.
 * Layout (header rows, action buttons, spacing) belongs to the caller.
 */
const PageHeading: React.FC<PageHeadingProps> = ({ title, subtitle, backTo }) => (
	<HeadingRow>
		{backTo && <BackLink {...backTo} />}
		<HeadingBlock>
			<HeadingTitle>{title}</HeadingTitle>
			{subtitle && <HeadingSubtitle>{subtitle}</HeadingSubtitle>}
		</HeadingBlock>
	</HeadingRow>
)

export default PageHeading
